module.exports = __webpack_public_path__ + "img/nextTerm.f6920389.png";